module.exports = __webpack_public_path__ + "static/media/barbarian_circle.1d68255d.svg";